import * as tslib_1 from "tslib";
import loadMoreConversationsFromServer from './helpers/loadMoreConversationsFromServer';
import loadMoreItemsFromServer from './helpers/loadMoreItemsFromServer';
import { LOAD_MORE_ROW_COUNT } from '../data-loading/TableLoadingConstants';
import { action } from 'satcheljs/lib/legacy';
import { onLoadMoreRowsFailed, onLoadMoreRowsSucceeded } from './onLoadMoreRowsCompleted';
import { lazyLoadMoreFindItemSearch } from 'owa-mail-execute-search-actions';
/**
 * Load more rows from server to the given table
 * @param tableView to be loaded
 */
function loadMoreRowsFromServer(tableView) {
    tableView.isLoading = true;
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            loadMoreConversationsFromServer(tableView);
            break;
        case 1 /* Message */:
            loadMoreItemsFromServer(tableView);
            break;
    }
}
/**
 * Load more data in table
 * @param tableView to be loaded
 */
export default action('loadMoreInTable')(function loadMoreInTable(tableView) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rowsToLoad, localItemsLeft, tableQuery, loadMoreFindItemSearchAction;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!tableView) {
                        throw new Error('Selected tableview must not be null if loadMoreRows is being called.');
                    }
                    rowsToLoad = LOAD_MORE_ROW_COUNT;
                    if (tableView.currentLoadedIndex < tableView.rowKeys.length) {
                        localItemsLeft = tableView.rowKeys.length - tableView.currentLoadedIndex;
                        if (localItemsLeft >= rowsToLoad) {
                            // We have enough to satisfy current range, so render that. No need to go to the server
                            tableView.currentLoadedIndex += rowsToLoad;
                            return [2 /*return*/];
                        }
                        // We have more items locally, but not enough to satisfy current range.
                        // Render what we have and also go to the server
                        tableView.currentLoadedIndex = tableView.rowKeys.length;
                    }
                    if (!(tableView.tableQuery.type == 0 /* Folder */ ||
                        tableView.tableQuery.type == 2 /* Group */)) return [3 /*break*/, 1];
                    loadMoreRowsFromServer(tableView);
                    return [3 /*break*/, 3];
                case 1:
                    if (!(tableView.tableQuery.type === 1 /* Search */)) return [3 /*break*/, 3];
                    tableQuery = tableView.tableQuery;
                    if (!(tableQuery.searchScope.kind === "SharedFolders" /* SharedFolders */)) return [3 /*break*/, 3];
                    return [4 /*yield*/, lazyLoadMoreFindItemSearch.import()];
                case 2:
                    loadMoreFindItemSearchAction = _a.sent();
                    loadMoreFindItemSearchAction(tableView.currentLoadedIndex - 1 /* offset */, tableView, 'loadMoreInTable' /* actionSource */, onLoadMoreRowsSucceeded, onLoadMoreRowsFailed);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=loadMoreInTable.js.map